import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment, EventsSearchParam } from 'src/index';
import { ViewerIndexService } from 'src/index/services.index';
import { Accessible } from '../../shared/mixins/accessible.mixin';

@Component({
    selector: 'meta-viewer-calendar',
    templateUrl: './viewer-calendar.component.html',
    styleUrls: ['./viewer-calendar.component.css'],
})
export class ViewerCalendarComponent extends Accessible {
    public viewerIndexService = inject(ViewerIndexService);
    private route = inject(ActivatedRoute);

    @Output() doClose = new EventEmitter();

    config = { ...environment.calendarModule };

    hideFooter = this.config.hideFooter || environment.hideFooter;

    private contentType: 'course' | 'liquid' = this.route.snapshot.data['contentType'] || 'liquid';
    public mainId: string | undefined = this.contentType === 'course' ? this.route.snapshot.params['courseId'] : this.route.snapshot.params['publicationId'];

    fixedSearch: EventsSearchParam[] = [{
        facetField: 'courseId',
        value: this.mainId,
    }];

    onClose(): void {
        this.doClose.emit();
    }
}
